import React from "react";
import imgrd4 from '../../../assets/Images/r-d/rd_8.jpg'

const Research_Development_Forth = () => {
  const capabilities = [
    {
      title: "Market Research & Concept Validation",
      description:
        "Consumer trends, ingredient feasibility, dosage selection.",
    },
    {
      title: "Ingredient Evaluation",
      description:
        "Purity testing, supplier qualification, stability compatibility.",
    },
    {
      title: "Prototype Development",
      description:
        "Bench formulations, flavor optimization, texture refinement.",
    },
    {
      title: "Analytical & Stability Testing",
      description:
        "ICH-compliant accelerated and real-time stability studies.",
    },
    {
      title: "Pilot Batch & Scale-Up",
      description:
        "Process optimization and production validation.",
    },
    {
      title: "Regulatory Documentation",
      description:
        "FSSAI export documentation, CoA & specification sheets.",
    },
  ];

  return (
    <section className="w-full bg-[#f7f7f7] py-12 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center mb-12">
          <img
            src={imgrd4}
            alt="Research Development Lab"
            className="w-full h-[280px] sm:h-[420px] object-cover rounded-[40px]"
          />

          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#355931] leading-tight">
              Advanced R&D Infrastructure for {" "}
              
              <span className="bg-gradient-to-r from-[#355931] via-[#6b8f4e] to-[#A9C32C] bg-clip-text text-transparent">
                Next-Generation Nutraceuticals
              </span>
            </h2>

            <p className="mt-6 text-gray-500 text-sm sm:text-base leading-7 max-w-2xl">
                From innovative formulation development to scalable manufacturing solutions, our 
                R&D ecosystem is designed to create high-performance nutraceutical, effervescent, 
                and wellness products that meet evolving consumer expectations and global quality standards.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-10">
          {capabilities.map((item, index) => (
            <div key={index} className="flex gap-4 items-start">
              <span className="mt-2 w-4 h-4 rotate-45 border-4 border-[#355931] shrink-0"></span>

              <div>
                <h3 className="text-lg md:text-xl font-bold text-[#222] mb-3">
                  {item.title}
                </h3>

                <p className="text-gray-500 text-sm sm:text-base leading-7">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Research_Development_Forth;